<template>
    <div class="container">
        {{ date }} - {{ formatDate(now) }}
        <p>{{ dateDifference(formatDate(now), date ) }}</p>
    </div>
</template>

<script>
    let moment = require('moment');
    export default {
        name: 'ResetPassword',
        data() {
            return {
                date: '2018-09-18 11:06:30',
                now: moment(new Date())
            }
        },
        methods: {
            formatDate(dateToBeFormated) {
                return moment(dateToBeFormated).format('YYYY-MM-DD hh:mm:ss')
            },
            dateDifference(date1, date2) {
                let a = moment(date1)
                let b = moment(date2)
                return b.diff(a, 'hours');
            },

            //Fetch token 
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/auth/ResetPassword.vue